import React, { Component } from "react"
import identity from "lodash/identity"

/**
 * @description Allows to wrap a component with a HOC, which can be created dynamically using the incoming props
 *
 * @param {function} shouldUpdate - takes props and nextProps, decides should the HOC be recreated (generateHOC)
 * @param {function} generateHOC - takes props, returns a HOC that will be stored until next update
 *
 * @returns {function} - a HOC you created with generateHOC (stays the same until shouldUpdate returns true)
 */
export default (
  shouldUpdate = () => false,
  generateHOC = () => identity,
) => BaseComponent =>
  class DynamicHoc extends Component {
    constructor(props) {
      super(props)
      this.Component = generateHOC(this.props)(BaseComponent)
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
      if (shouldUpdate(this.props, nextProps)) {
        this.Component = generateHOC(nextProps)(BaseComponent)
      }
    }

    render() {
      const { Component, props } = this

      return <Component {...props} />
    }
  }
